// extracted by mini-css-extract-plugin
export default {"notes_layout":"Notes_notes_layout__NIQSB"};